import { Table, Tag, Spin, PageHeader, Select, Tabs, Button } from "antd";
import Column from "antd/lib/table/Column";
import { RollbackOutlined, UndoOutlined } from "@ant-design/icons";
import { relativeTimeThreshold } from "moment";
import React, { Component } from "react";

import Dialog from "../shared/dialog";

import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";

import WorkLifeReport from "../components/WorkLifeReport";
import ReactToPrint from "react-to-print";
import LeaderReport from "../components/LeaderReport";

const { Option } = Select;
const { TabPane } = Tabs;

// import ReactTable from "react-table";
// import "react-table/react-table.css";
class ForAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: this.props.lang,
      Datasource: [],
      DataSourceColumnTH: [],
      DataSourceColumnEN: [],
      Columns: [],
      query: "",
      queryPrim: "",
      results: [],
      resultsPrim: [],
      selectedRowKeys: [],
      selectedRowKeysPrim: [],

      searchBy: "EmpId",
      searchByPrim: "EmpId",
      DatasourcePrimary: [],
    };
    this.dialog = new Dialog();
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    this.setState({ language: nextProps.lang });
  }
  handleChangeStatus = (record) => {
    fetch(process.env.REACT_APP_API_URL + "/api/saveItemBackState", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: record.EmpId,
        ansformid: record.AnsFormId,
        remark: "",
        hrid: localStorage.getItem("EmpId"),
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        this.componentDidMount();
      });
  };
  spinnerControl() {
    this.setState({ spinner: !this.state.spinner });
  }

  componentDidMount() {
    this.spinnerControl();
    console.log("statequery", this.state.query);
    fetch(process.env.REACT_APP_API_URL + "/api/getEmpDataForBackState", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: "f18ddd26-f184-4bce-9368-0c613e055bc0",
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result", result);
        console.log("this.search", this.search.value);
        console.log("this.search", this.searchPrim);

        if (this.search.value == "") {
          this.setState({
            Datasource: result[0].EmpSelfList,
            Columns: result[0].Table[0].TableColumn,
            DatasourcePrimary: result[0].EmpPrimaryList,
            results: result[0].EmpSelfList,
            resultsPrim: result[0].EmpPrimaryList,
          });
        } else {
          this.setState({
            Datasource: result[0].EmpSelfList,
            Columns: result[0].Table[0].TableColumn,
            results: result[0].EmpSelfList,
            resultsPrim: result[0].EmpPrimaryList,
          });
          this.setState(
            {
              query: this.search.value,
            },
            () => {
              if (this.state.query && this.state.query.length > 0) {
                console.log("this.state.searchBy", this.state.searchBy);
                const allData = this.state.results;
                const dataToShow = [];
                allData.forEach((item) => {
                  const searchString = this.state.query.toUpperCase();
                  if (item[this.state.searchBy].includes(searchString)) {
                    dataToShow.push(item);
                  }
                  this.setState({
                    Datasource: dataToShow,
                  });
                });
              } else {
                this.setState({
                  Datasource: this.state.results,
                });
              }
            }
          );
          if (this.searchPrim !== undefined) {
            this.setState(
              {
                queryPrim: this.searchPrim.value,
              },
              () => {
                if (this.state.queryPrim && this.state.queryPrim.length > 0) {
                  console.log("this.state.searchBy", this.state.searchByPrim);
                  const allData = this.state.resultsPrim;
                  const dataToShow = [];
                  allData.forEach((item) => {
                    const searchString = this.state.queryPrim.toUpperCase();
                    if (item[this.state.searchByPrim].includes(searchString)) {
                      dataToShow.push(item);
                    }
                    this.setState({
                      DatasourcePrimary: dataToShow,
                    });
                  });
                } else {
                  this.setState({
                    DatasourcePrimary: this.state.resultsPrim,
                  });
                }
              }
            );
          }
        }

        if (this.state.DataSourceColumnTH.length == 0) {
          this.state.Columns.forEach((e) => {
            if (e.ColumnKeyTH !== "EvaluateStatus") {
              this.state.DataSourceColumnTH.push({
                title: e.ColumnNameTH,
                dataIndex: e.ColumnKeyTH,
                OrderBy: e.ColumnOrder,
              });
            } else {
              this.state.DataSourceColumnTH.push({
                title: e.ColumnNameTH,
                dataIndex: e.ColumnKeyTH,
                OrderBy: e.ColumnOrder,
                render: (e, record) => {
                  if (e == 3) {
                    return (
                      <div>
                        <Tag
                          text-align="center"
                          color="green"
                          style={{ fontSize: "15px" }}
                        >
                          ประเมินสำเร็จ
                        </Tag>
                        <RollbackOutlined
                          onClick={() => {
                            this.handleChangeStatus(record);
                          }}
                          style={{ fontSize: "20px", color: "red" }}
                        />
                      </div>
                    );
                  } else if (e == 1) {
                    return <Tag color="red">ยังไม่ได้ประเมิน</Tag>;
                  } else if (e == 2) {
                    return <Tag color="volcano">กำลังประเมิน</Tag>;
                  }
                },
              });
            }
          });
          this.state.Columns.forEach((e) => {
            if (e.ColumnKeyEN !== "EvaluateStatus") {
              this.state.DataSourceColumnEN.push({
                title: e.ColumnNameEN,
                dataIndex: e.ColumnKeyEN,
                OrderBy: e.ColumnOrder,
              });
            } else {
              this.state.DataSourceColumnEN.push({
                title: e.ColumnNameEN,
                dataIndex: e.ColumnKeyEN,
                OrderBy: e.ColumnOrder,
                render: (e, record) => {
                  if (e == 3) {
                    return (
                      <div>
                        <Tag
                          text-align="center"
                          color="green"
                          style={{ fontSize: "15px" }}
                        >
                          Completed
                        </Tag>
                        <RollbackOutlined
                          onClick={() => {
                            this.handleChangeStatus(record);
                          }}
                          style={{ fontSize: "20px", color: "red" }}
                        />
                      </div>
                    );
                  } else if (e == 1) {
                    return <Tag color="red">No Record</Tag>;
                  } else if (e == 2) {
                    return <Tag color="volcano">In Progress</Tag>;
                  }
                },
              });
            }
          });
          this.setState({
            DataSourceColumnTH: this.state.DataSourceColumnTH.sort(
              (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
            ),
            DataSourceColumnEN: this.state.DataSourceColumnEN.sort(
              (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
            ),
          });
        }
        console.log(
          "aisomcioasmicoamoiscmoiamsocamosciasc",
          this.state.DataSourceColumnTH
        );

        this.spinnerControl();
      });
  }
  changeLangFunction(item) {
    localStorage.setItem("Language", item);
    this.setState({ language: item });
  }

  getSearchResults = (query) => {
    console.log("query", query);
    const allData = this.state.results;
    const dataToShow = [];
    allData.forEach((item) => {
      const searchString = query.toUpperCase();
      if (item[this.state.searchBy].includes(searchString)) {
        dataToShow.push(item);
      }
    });
    this.setState({
      Datasource: dataToShow,
    });
  };
  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      () => {
        if (this.state.query && this.state.query.length > 0) {
          this.getSearchResults(this.state.query);
        } else {
          this.setState({
            Datasource: this.state.results,
          });
        }
      }
    );
  };
  selectRow = (record, rowIndex) => {
    console.log("record", record);
    console.log("rowIndex", rowIndex);

    const selectedRowKeys = [...this.state.selectedRowKeys];
    if (selectedRowKeys.indexOf(record.EmpId) >= 0) {
      console.log("record.EmpId", record.EmpId);
      selectedRowKeys.splice(selectedRowKeys.indexOf(record.EmpId), 1);
    } else {
      console.log("record.EmpId 2", record.EmpId);
      selectedRowKeys.pop();
      selectedRowKeys.push(record.EmpId);
    }

    this.setState({ selectedRowKeys });
  };
  onSelectedRowKeysChange = (selectedRowKeys) => {
    console.log("selectedRowKeys", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };
  onSelectedRowKeysChangePrim = (selectedRowKeysPrim) => {
    console.log("selectedRowKeys", selectedRowKeysPrim);
    this.setState({ selectedRowKeysPrim });
  };
  selectRowPrim = (record, rowIndex) => {
    console.log("record", record);
    console.log("rowIndex", rowIndex);

    const selectedRowKeysPrim = [...this.state.selectedRowKeysPrim];
    if (selectedRowKeysPrim.indexOf(record.EmpId) >= 0) {
      console.log("record.EmpId", record.EmpId);
      selectedRowKeysPrim.splice(selectedRowKeysPrim.indexOf(record.EmpId), 1);
    } else {
      console.log("record.EmpId 2", record.EmpId);
      selectedRowKeysPrim.pop();
      selectedRowKeysPrim.push(record.EmpId);
    }

    this.setState({ selectedRowKeysPrim });
  };
  handleSearchByChange = (value) => {
    this.setState(
      {
        searchBy: value,
      },
      () => {
        if (this.state.query && this.state.query.length > 0) {
          this.getSearchResults(this.state.query);
        } else {
          this.setState({
            Datasource: this.state.results,
          });
        }
      }
    );
  };
  handleSearchByChangePrimary = (value) => {
    this.setState(
      {
        searchByPrim: value,
      },
      () => {
        if (this.state.queryPrim && this.state.queryPrim.length > 0) {
          this.getSearchResultsPrim(this.state.queryPrim);
        } else {
          this.setState({
            DatasourcePrimary: this.state.resultsPrim,
          });
        }
      }
    );
  };
  handleInputChangePrim = () => {
    console.log("this.search.value1", this.search.value);
    this.setState(
      {
        queryPrim: this.searchPrim.value,
      },
      () => {
        if (this.state.queryPrim && this.state.queryPrim.length > 0) {
          this.getSearchResultsPrim(this.state.queryPrim);
        } else {
          this.setState({
            DatasourcePrimary: this.state.resultsPrim,
          });
        }
      }
    );
  };
  getSearchResultsPrim = (queryPrim) => {
    console.log("query", queryPrim);
    const allData = this.state.resultsPrim;
    const dataToShow = [];
    allData.forEach((item) => {
      const searchString = queryPrim.toUpperCase();
      if (item[this.state.searchByPrim].includes(searchString)) {
        dataToShow.push(item);
      }
    });
    this.setState({
      DatasourcePrimary: dataToShow,
    });
  };

  refreshList() {
    console.log("this.search refreshList", this.search.value);

    this.search.value = "";
    this.setState({
      Datasource: this.state.results,
    });
  }
  refreshListPrim() {
    this.searchPrim.value = "";
    console.log("this.search refreshListPrim", this.search.value);
    this.setState({
      DatasourcePrimary: this.state.resultsPrim,
    });
  }
  changeTabs(key) {}
  render() {
    const {
      Datasource,
      DataSourceColumnTH,
      DataSourceColumnEN,
      selectedRowKeys,
      DatasourcePrimary,
      selectedRowKeysPrim,
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectedRowKeysChange,
    };
    const rowSelectionPrim = {
      selectedRowKeysPrim,
      onChange: this.onSelectedRowKeysChangePrim,
    };
    return (
      <Spin tip="Loading..." spinning={this.state.spinner}>
        <div style={{ marginLeft: 15, marginRight: 15 }}>
          <React.Fragment>
            <PageHeader
              className="site-page-header"
              onBack={() => window.history.back()}
              title={
                this.state.language == "TH" ? "ย้อนสถานะ" : "Reverse State"
              }
            ></PageHeader>
            <Tabs
              defaultActiveKey="1"
              onChange={(e) => this.changeTabs(e)}
              visible
              centered
            >
              <TabPane tab="ประเมินตนเอง" key="1">
                <label>Search By : </label>
                <Select
                  bordered
                  style={{ border: "solid 1px" }}
                  defaultValue={
                    this.state.language == "TH"
                      ? "รหัสพนักงาน"
                      : "Personnel Code"
                  }
                  onChange={(e) => this.handleSearchByChange(e)}
                >
                  <Option value={"EmpId"} title="รหัสพนักงาน">
                    {" "}
                    {this.state.language == "TH"
                      ? "รหัสพนักงาน"
                      : "Personnel Code"}{" "}
                  </Option>
                  <Option value={"FirstNameTH"} title="ชื่อ">
                    {" "}
                    {this.state.language == "TH" ? "ชื่อ" : "Firstname"}{" "}
                  </Option>
                </Select>
                <input
                  className="search-field"
                  placeholder={
                    this.state.language == "TH" &&
                    this.state.searchBy == "EmpId"
                      ? "รหัสพนักงาน"
                      : "Personnel Code" &&
                        this.state.language == "TH" &&
                        this.state.searchBy == "FirstNameTH"
                      ? "ชื่อ"
                      : "Firstname"
                  }
                  ref={(input) => (this.search = input)}
                  onChange={this.handleInputChange}
                  autoFocus
                />
                <UndoOutlined onClick={() => this.refreshList()} />
                <Table
                  rowSelection={rowSelection}
                  dataSource={Datasource}
                  columns={
                    this.state.language == "TH"
                      ? DataSourceColumnTH
                      : DataSourceColumnEN
                  }
                  onRow={(record, rowIndex) => ({
                    onClick: () => {
                      this.selectRow(record, rowIndex);
                    },
                  })}
                >
                  <Column />
                </Table>
              </TabPane>

              <TabPane
                tab="ขั้นที่ 1 ประเมินผลการปฎิบัติงานผู้ใต้สังกัด"
                key="2"
              >
                <label>Search By : </label>
                <Select
                  bordered
                  style={{border: "solid 1px" }}
                  defaultValue={
                    this.state.language == "TH"
                      ? "รหัสพนักงาน"
                      : "Personnel Code"
                  }
                  onChange={(e) => this.handleSearchByChangePrimary(e)}
                >
                  <Option value={"EmpId"} title="รหัสพนักงาน">
                    {" "}
                    {this.state.language == "TH"
                      ? "รหัสพนักงาน"
                      : "Personnel Code"}{" "}
                  </Option>
                  <Option value={"FirstNameTH"} title="ชื่อ">
                    {" "}
                    {this.state.language == "TH" ? "ชื่อ" : "Firstname"}{" "}
                  </Option>
                </Select>
                <input
                  className="search-field"
                  placeholder={
                    this.state.language == "TH" &&
                    this.state.searchByPrim == "EmpId"
                      ? "รหัสพนักงาน"
                      : "Personnel Code" &&
                        this.state.language == "TH" &&
                        this.state.searchByPrim == "FirstNameTH"
                      ? "ชื่อ"
                      : "Firstname"
                  }
                  ref={(input) => (this.searchPrim = input)}
                  onChange={this.handleInputChangePrim}
                  autoFocus
                />
                <UndoOutlined onClick={() => this.refreshListPrim()} />
                <Table
                  rowSelection={rowSelectionPrim}
                  dataSource={DatasourcePrimary}
                  columns={
                    this.state.language == "TH"
                      ? DataSourceColumnTH
                      : DataSourceColumnEN
                  }
                  onRow={(record, rowIndex) => ({
                    onClick: () => {
                      this.selectRowPrim(record, rowIndex);
                    },
                  })}
                >
                  <Column />
                </Table>
              </TabPane>

              {/* render tab for print report */}
              <TabPane tab="ผลการประเมินภาวะผู้นำ" key="3">
                 <div>
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <div
                          style={{
                            textAlign: "center",
                            margin: "auto",
                            marginBlock: 15,
                          }}
                        >
                  
                          <Button type="primary">พิมพ์รายงาน</Button>
                        </div>
                      );
                    }}
                    content={() => this.componentRef1}
                  />
  

                    <div ref={(el) => (this.componentRef1 = el)}>
                      <LeaderReport />
                    </div>
             
                </div>

                   </TabPane> 
             

           
              <TabPane tab="ผลการประเมินคุณภาพชีวิต" key="4">
                 <div>
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <div
                          style={{
                            textAlign: "center",
                            margin: "auto",
                            marginBlock: 15,
                          }}
                        >
                  
                          <Button type="primary">พิมพ์รายงาน</Button>
                        </div>
                      );
                    }}
                    content={() => this.componentRef}
                  />
  

                    <div ref={(el) => (this.componentRef = el)}>
                      <WorkLifeReport />
                    </div>
             
                </div>

                   </TabPane> 
             


            </Tabs>
          </React.Fragment>
        </div>
      </Spin>
    );
  }
}

export default ForAdmin;
